module.exports = __webpack_public_path__ + "img/125ne.9f39324d.svg";